/* global _spef */
/* eslint-disable no-confusing-arrow */

export const sESearch = () => typeof _spef !== 'undefined' ? _spef.push(['trackGoal', 1]) : null;

export const sEClickOut = () => typeof _spef !== 'undefined' ? _spef.push(['trackGoal', 3]) : null;
